export default function getResource(label, vars = []) {
    const resources = {
        reschedule: 'Reschedule',
        cancel: 'Cancel',
        bookAgain: 'Book Again',
        viewProduct: 'View Product Recs',
        cancelRSVP: 'Cancel RSVP',
        rsvp: 'RSVP',
        free: 'FREE'
    };

    return resources[label];
}
